import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  DeleteSubscription as DeleteSubscriptionGenerated,
  DeleteSubscriptionVariables as DeleteSubscriptionVariablesGenerated,
} from "core/queries/__generated__/DeleteSubscription";

export interface DeleteSubscriptionResponse
  extends DeleteSubscriptionGenerated {}
export interface DeleteSubscriptionVariables
  extends DeleteSubscriptionVariablesGenerated {}

export const deleteSubscription = gql`
  mutation DeleteSubscription(
    $resourceId: ID!
    $resourceType: NotificationResource!
    $userId: ID!
  ) {
    deleteSubscription(
      resourceId: $resourceId
      resourceType: $resourceType
      userId: $userId
    ) {
      success
    }
  }
`;

interface UseDeleteSubscriptionOptions {
  refetchQueries?: string[];
  onCompleted?: (data: any) => void;
  awaitRefetchQueries?: boolean;
}

export const useDeleteSubscription = ({
  refetchQueries = [],
  onCompleted,
  awaitRefetchQueries = false,
}: UseDeleteSubscriptionOptions) =>
  useMutation<DeleteSubscriptionResponse, DeleteSubscriptionVariables>(
    deleteSubscription,
    {
      refetchQueries,
      onCompleted,
      awaitRefetchQueries,
    },
  );
